import DailyBalanceSheetReportPrintComponent from './daily_balance_sheet_report_print.component';

let DailyBalanceSheetReportPrintModule = angular.module('printDailyBalanceSheetReport', [
])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$stateProvider
			.state('printDailyBalanceSheetReport', {
				url: '/print-daily-balance-sheet-report',
				component: 'printDailyBalanceSheetReport',
				data: {
					requireLogin: true,
					requireACL: 'branch_mgmt_daily_balance_sheet.all'
				},
			});
	})

	.component('printDailyBalanceSheetReport', DailyBalanceSheetReportPrintComponent)

	.name;

export default DailyBalanceSheetReportPrintModule;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/daily_balance_sheet/print/daily_balance_sheet_report/index.js